import styled from 'styled-components';

const ContentContainer = styled.div`
  display: block;
  max-width: 1205px;
`;

export default ContentContainer;
